export function extractBackendErrorMessage(error: any): string {
  if (!error) {
    return 'Erro desconhecido.';
  }

  const payload = normalizeErrorPayload(error?.error);

  if (typeof payload === 'string') {
    const text = payload.trim();
    if (text) {
      return text;
    }
  }

  if (typeof error?.message === 'string' && error.message.trim()) {
    const message = error.message.trim();
    if (!/^http failure response/i.test(message)) {
      return message;
    }
  }

  if (payload) {
    if (typeof payload?.message === 'string' && payload.message.trim()) {
      return payload.message.trim();
    }

    if (typeof payload?.status === 'string' && payload.status.trim()) {
      return payload.status.trim();
    }

    if (typeof payload?.error === 'string' && payload.error.trim()) {
      return payload.error.trim();
    }

    if (Array.isArray(payload?.errors) && payload.errors.length > 0) {
      const joined = payload.errors
        .map((item: any) => typeof item === 'string' ? item.trim() : (item?.message || item?.defaultMessage || item?.status || ''))
        .filter((item: string) => !!item)
        .join('\n');
      if (joined) {
        return joined;
      }
    }
  }

  if (typeof error?.statusText === 'string' && error.statusText.trim()) {
    return error.statusText.trim();
  }

  try {
    const serialized = JSON.stringify(payload || error);
    if (serialized && serialized !== '{}') {
      return serialized;
    }
  } catch (_ignored) {
  }

  return 'Erro desconhecido.';
}

function normalizeErrorPayload(payload: any): any {
  if (!payload) {
    return payload;
  }

  if (payload instanceof ArrayBuffer) {
    return decodeArrayBufferPayload(payload);
  }

  if (ArrayBuffer.isView(payload) && payload.buffer instanceof ArrayBuffer) {
    return decodeArrayBufferPayload(payload.buffer);
  }

  return payload;
}

function decodeArrayBufferPayload(buffer: ArrayBuffer): any {
  try {
    const text = new TextDecoder('utf-8').decode(new Uint8Array(buffer)).trim();
    if (!text) {
      return null;
    }

    try {
      return JSON.parse(text);
    } catch (_ignored) {
      return text;
    }
  } catch (_ignored) {
    return null;
  }
}